import {default as MuiButton} from "@mui/material/Button";
import React from "react";
import {ButtonPropTypes} from "./ButtonPropTypes";

export interface ButtonProps {
    label: string,
    onClick: (event?: any) => void,
    color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning',
    variant?: ButtonPropTypes.Variant,
    size?: ButtonPropTypes.Size,
    autoFocus?: boolean,
    disabled?: boolean;
    icon?: React.ReactNode;
}

export function Button({color, autoFocus, onClick, variant, size, label, disabled, icon}: ButtonProps) {
    return (
        <MuiButton
            color={color}
            autoFocus={autoFocus}
            onClick={onClick}
            variant={variant}
            size={size}
            disabled={disabled}
            startIcon={icon}
        >
            {label}
        </MuiButton>
    )
}
